import * as React from 'react';

import Retracked from 'js/app/retracked';

import useUrlData from 'bundles/shared-articles/hooks/useArticleUrlData';
import PageDataErrorHandler from 'bundles/unified-seo-content-common/components/shared/PageDataErrorHandler';
import HubPageSkeleton from 'bundles/unified-seo-content-common/components/skeletons/HubPageSkeleton';
import { SEO_CONTENT_PAGE_TYPE } from 'bundles/unified-seo-content-common/constants';
import { useSeoContentMainHubPageQuery } from 'bundles/unified-seo-content-common/hooks/useSeoContentMainHubPageQuery';
import ResourceMainHubPage from 'bundles/unified-seo-content-common/pages/resource/ResourceMainHubPage';
import PageInfoProvider from 'bundles/unified-seo-content-common/providers/PageInfoProvider';

const ResourceMainHubPageRoot = () => {
  const pageType = SEO_CONTENT_PAGE_TYPE.resources;

  const { isPreview, subfolderLocaleCode } = useUrlData();

  const pageData = useSeoContentMainHubPageQuery({
    pageType,
    preview: isPreview,
    subfolderLocaleCode,
  });

  const { isHubPageDataLoading } = pageData;

  if (isHubPageDataLoading) {
    return <HubPageSkeleton />;
  }

  const notFoundError = !pageData.title;

  if (notFoundError) return <PageDataErrorHandler />;

  return (
    <PageInfoProvider pageType={pageType}>
      <ResourceMainHubPage pageData={pageData} />
    </PageInfoProvider>
  );
};

export default Retracked.createTrackedContainer(() => ({
  namespace: {
    app: 'resources',
    page: 'resource_main_hub_page',
  },
}))(ResourceMainHubPageRoot);
